import Image from 'next/image';
import Link from 'next/link';
import { SetStateAction } from 'react';
import styled from 'styled-components';
interface IProps {
  openModal2: boolean;
  setOpenModal2: React.Dispatch<SetStateAction<boolean>>;
}
const StylPopup = styled.div`
  animation: drop 0.5s ease forwards;
  @keyframes drop {
    0% {
      transform: translateY(0px);
    }
    70% {
      transform: translateY(30px);
    }
    100% {
      transform: translateY(0px);
    }
  }
`;
const Thanks = ({ openModal2, setOpenModal2 }: IProps) => {
  return (
    <div
      className="fixed top-0 left-0 w-screen h-screen bg-[#0c0d0dc0] flex justify-center items-center z-[2000]"
      onClick={() => setOpenModal2(false)}
    >
      <StylPopup
        id="thanks"
        className="bg-white flex flex-col justify-center items-center max-w-[80%] p-5 md:p-10 relative"
        onClick={e => e.stopPropagation()}
      >
        <Image
          src="https://res.cloudinary.com/see-sight-tours/image/upload/v1685544129/Remaining%20images/Reviews/radix-icons_cross-2_mlrxew.svg"
          width={40}
          height={40}
          alt="cross-button"
          className="hidden xl:block absolute top-2 left-2 z-10 hover:cursor-pointer"
          onClick={() => {
            setOpenModal2(false);
          }}
        />
        <Image
          src="https://res.cloudinary.com/see-sight-tours/image/upload/v1685544129/Remaining%20images/Reviews/radix-icons_cross-2_mlrxew.svg"
          width={20}
          height={20}
          alt="cross-button"
          className="block xl:hidden absolute top-2 left-2 z-10 hover:cursor-pointer"
          onClick={() => {
            setOpenModal2(false);
          }}
        />
        <h2 className="text-2xl sm:text-4xl lg:text-5xl font-bold text-center">
          THANK YOU
        </h2>
        <p className="text-lg md:text-2xl font-normal mt-5 text-center">
          We have received your application. We will inform you shortly.
        </p>
        <Link href={'/'} className="mt-5">
          <button className="py-3 px-6 rounded-full text-base sm:text-lg font-normal bg-primary hover:bg-[#2E3D7A] active:bg-[#2E3D7A] text-white">
            Back to Home
          </button>
        </Link>

        <div className="flex gap-5 justify-center items-center mt-5">
          <Link href="https://www.facebook.com/tripshepherd/" target="_blank">
            <Image
              src={
                'https://res.cloudinary.com/see-sight-tours/image/upload/v1690448088/icons-website/Facebook_-_Negative_govvbc.svg'
              }
              width={30}
              height={30}
              alt="https://www.facebook.com/tripshepherd/"
            />
          </Link>

          <Link href={'https://x.com/tripshepherdINC'} target="_blank">
            <Image
              src={
                'https://res.cloudinary.com/see-sight-tours/image/upload/v1690448088/icons-website/Twitter_-_Negative_ja2ys5.svg'
              }
              width={30}
              height={30}
              alt="https://x.com/tripshepherdINC"
            />
          </Link>

          <Link
            href={'https://www.youtube.com/user/SeeSightTours'}
            target="_blank"
          >
            <Image
              src={
                'https://res.cloudinary.com/see-sight-tours/image/upload/v1690448088/icons-website/Group_1_a7g7ts.svg'
              }
              width={30}
              height={30}
              alt="https://www.youtube.com/user/SeeSightTours"
            />
          </Link>
        </div>
      </StylPopup>
    </div>
  );
};

export default Thanks;
